/**
 * GTM dataLayer: once per browser tab session when the user is authenticated and
 * the main app shell loads (after GitHub OAuth completes). Prefer this over the
 * pre-redirect "Continue with GitHub" click for conversion tags.
 *
 * GTM: Custom Event = {@link GTM_OAUTH_SUCCESS_APP_LOAD_EVENT}. Payload includes
 * `entry_utm_campaign` from first-touch `appFirstTouchAttribution` (captured in
 * `_app` on load). For Try-for-free-only conversions, add trigger condition
 * `entry_utm_campaign` equals `try_for_free` (Webflow: `?utm_campaign=try_for_free`).
 */

import { getAppFirstTouchUtmCampaignForGtm } from "@/lib/appFirstTouchAttribution";

export const GTM_OAUTH_SUCCESS_APP_LOAD_EVENT =
  "blacksmith_oauth_success_app_load";

const SESSION_STORAGE_KEY = "bs_gtm_oauth_success_app_load_sent";

export function emitOauthSuccessAppLoadGtmOnce(): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    if (window.sessionStorage.getItem(SESSION_STORAGE_KEY) === "1") {
      return;
    }
  } catch {
    return;
  }
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({
    event: GTM_OAUTH_SUCCESS_APP_LOAD_EVENT,
    entry_utm_campaign: getAppFirstTouchUtmCampaignForGtm(),
  });
  try {
    window.sessionStorage.setItem(SESSION_STORAGE_KEY, "1");
  } catch {
    // ignore
  }
}

/** When showing the signed-out gate so a later login can emit again (same tab). */
export function clearOauthSuccessAppLoadGtmSessionFlag(): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } catch {
    // ignore
  }
}
